export default __webpack_public_path__ + "static/media/Jesse_Turek-Resume.c4805bd2.pdf";